import { render } from "./postDetails.vue?vue&type=template&id=04376622"
import script from "./postDetails.vue?vue&type=script&lang=js"
export * from "./postDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__